import { ref, watch } from 'vue'

export const useCurrentUser = () => {

    const currentUser = ref(null)
    const { isSignedIn, user: clerkUser, isLoaded } = useUser()

    watch(clerkUser, async (newClerkUser) => {
        if (newClerkUser?.id) {
            const { data } = await useFetch('/api/current-user', {
                body: {
                    clerkUserId: newClerkUser.id,
                    email: newClerkUser.emailAddresses[0]?.emailAddress
                },
                method: 'POST'
            })
            if (data.value) {
                currentUser.value = data.value as any // Type assertion to fix type mismatch
            }
        }
    }, { immediate: true })

    return {
        clerkUser,
        currentUser,
        isSignedIn,
        isLoaded
    }
} 